
<template>
  <div class="login-container">
    <div class="content" :style="'background-image:url('+backimg_login+')'">
      <div class="header__title">{{ $t('login.dlym01') }}</div>
      <div class="notice-line" style="justify-content: space-between;">
        <div style="display: flex;">
          <div>{{ $t('login.dlym02') }}</div>
          <div class="main" @click="toRegistry">{{ $t('login.dlym03') }}</div>
        </div>
        <img class="service_icon" src="@/assets/portal/auth/icon_客服.svg" alt="" @click="$emit('showService')">
      </div>
      <van-form class="form" @submit="onSubmit">
        <van-field
          v-model="form.loginname"
          autocomplete="off"
          clearable
          name="账号"
          label=""
          :placeholder="$t('login.dlym04')"
          :rules="[
            {
              required: true,
            },
          ]"
        >
          <template #left-icon>
            <div class="cell_icon1" />
          </template>
          <!-- <template #left-icon>
            <van-icon style="margin:auto;line-height:40px;padding:0px 10px" size="20" color="rgba(121,135,164,1)" name="contact" />
          </template> -->
        </van-field>
        <van-field
          v-model="form.loginpwd"
          autocomplete="off"
          type="password"
          center
          clearable
          name="密码"
          label=""
          :placeholder="$t('login.dlym05')"
          :rules="[
            { required: true,
            }
          ]"
        >
          <template #left-icon>
            <div class="cell_icon2" />
          </template>
          <!-- <template #left-icon>
            <van-icon style="margin:auto;line-height:40px;padding:0px 10px" size="20" color="rgba(121,135,164,1)" name="lock" />
          </template> -->
        </van-field>
        <div class="notice-line">
          <img class="checkIcon" :src="isRememberPassword?checkedBox:unCheckBox" alt="" @click="isRememberPassword=!isRememberPassword;">
          <div class="marginLeft8">{{ $t('login.dlym06') }}</div>
          <div class="forget" @click="goMore">{{ $t('login.dlym07') }}</div>
          <!-- <van-checkbox v-model="isRememberPassword" :checked-color="checkedColor" icon-size="16px" shape="square">{{ $t('login.dlym06') }}</van-checkbox> <div class="forget" @click="goMore">{{ $t('login.dlym07') }}</div> -->
        </div>
        <div v-if="showCaptcha" id="cap_iframe" />
        <div style="margin-top: 2vh;">
          <!-- :disabled="disabled" -->
          <van-button
            class="submit_btn"
            block
            :loading="loading"
            type="info"
            :loading-text="$t('login.dlym09')"
            native-type="submit"
          >{{ $t('login.dlym08') }}</van-button>
        </div>
      </van-form>

      <!-- <div class="notice-line">
        <div class="main" style="margin: auto;" @click="$emit('showService')">{{ $t('register.zcym09') }}</div>
      </div> -->
      <div class="other-type">
        <div class="line" />
        <div class="text">使用以下方式<span class="main-text">免注册</span>登录</div>
        <div class="line" />
      </div>
      <div class="other-type">
        <div v-for="item in loginTypeList" :key="item.label" class="type-item" @click="goOtherLogin(item.label)">
          <img :src="item.icon" alt=""></div>
      </div>
      <!-- <button @click="login">使用Facebook登录</button> -->
      <!-- <fb-signin-button
          :params="fbSignInParams"
          @success="onSignInSuccess"
          @error="onSignInError">
        Sign in with Facebook
      </fb-signin-button> -->
      <!-- <fb:login-button scope="public_profile,email" onlogin="checkLoginState();">
      </fb:login-button>

      <div id="status">
      </div> -->
      <!-- <button id="CaptchaId" type="button">验证</button> -->
    </div>
    <div class="close-icon" name="cross" @click="$emit('close')" />
  </div>
</template>

<script>
import { getUToken, getBotinfo } from '@/api/user'
import fbIcon from '@/assets/portal/auth/图标_fb.svg'
import googleIcon from '@/assets/portal/auth/图标_google.svg'
import tgIcon from '@/assets/portal/auth/图标_tg.svg'
import checkedBox from '@/assets/portal/auth/复选框_s@2x.webp'
import checkedBoxBlackGold from '@/assets/blackgold/复选框_s备份@2x.webp'
import unCheckBox from '@/assets/portal/auth/复选框_n@2x.webp'
export default {
  name: 'Login',
  data() {
    return {
      checkedBox: process.env.VUE_APP_BASE_THEME ? checkedBoxBlackGold : checkedBox,
      unCheckBox: unCheckBox,
      loginTypeList: [
        { icon: tgIcon, label: 'tg' }, { icon: fbIcon, label: 'fb' }, { icon: googleIcon, label: 'google' }
      ],
      showCaptcha: true,
      disabled: true,
      form: {
        loginname: undefined,
        loginpwd: undefined
      },
      loading: false,
      registryVisible: false,
      isRememberPassword: true,
      boturl: '',
      backimg_login: '',
      fbSignInParams: { scope: 'email,user_likes',
        return_scopes: true }
    }
  },
  watch: {
    // $route: {
    //   handler(route) {
    //     this.redirect = (route.query && route.query.redirect) || process.env.VUE_APP_BASE_PATH
    //   },
    //   immediate: true
    // }
  },
  created() {
    this.backimg_login = this.$store.getters.sysInfo.backimg_login
  },
  async mounted() {
    this.setCaptcha()
    getBotinfo().then(res => {
      this.boturl = res.boturl
    })
  },
  methods: {
    login() {
      FB.login(response => {
        if (response.authResponse) {
          console.log('欢迎! Facebook ID:', response.authResponse.userID)
          this.getUserData() // 获取用户数据
        } else {
          console.log('用户拒绝登录')
        }
      }, { scope: 'email' }) // 请求用户的基本信息，如邮箱等
    },
    getUserData() {
      FB.api('/me', 'GET', { fields: 'name,email' }, (response) => {
        console.log('用户信息:', response)
        // 这里可以处理登录后的用户数据，例如存储到Vuex或发送到后端等。
      })
    },
    onSignInSuccess(response) {
      // FB.api('/me', dude => {
      //   console.log(`Good to see you, ${dude.name}.`)
      // })
      console.log(response) // 返回第三方的登录信息 tolen等
    },
    onSignInError(error) {
    },
    statusChangeCallback(response) { // Called with the results from FB.getLoginStatus().
      console.log('statusChangeCallback')
      console.log(response) // The current login status of the person.
      if (response.status === 'connected') { // Logged into your webpage and Facebook.
        testAPI()
      } else { // Not logged into your webpage or we are unable to tell.
        document.getElementById('status').innerHTML = 'Please log ' +
          'into this webpage.'
      }
    },
    checkLoginState() { // Called when a person is finished with the Login Button.
      FB.getLoginStatus((response) => { // See the onlogin handler
        statusChangeCallback(response)
      })
    },
    testAPI() { // Testing Graph API after login.  See statusChangeCallback() for when this call is made.
      console.log('Welcome!  Fetching your information.... ')
      FB.api('/me', (response) => {
        console.log('Successful login for: ' + response.name)
        document.getElementById('status').innerHTML =
          'Thanks for logging in, ' + response.name + '!'
      })
    },
    goOtherLogin(type) {
      if (type === 'tg') {
        // getBotinfo().then(res => {
        window.open(this.boturl.split('?')[0])
        // })
        // this.to('/auth/loginByTg')
      } else {
        this.$toast.fail('敬请期待')
        this.login()
      }
    },
    async setCaptcha() {
      this.showCaptcha = true
      await this.$nextTick()
      try {
        const getUTokenRes = await getUToken()
        const CaptchaAppId = getUTokenRes.CaptchaAppId
        if (CaptchaAppId) {
          var captcha = new TencentCaptcha(document.getElementById('cap_iframe'), CaptchaAppId, this.callback, { 'enableAutoCheck': true })
          captcha.show()
        } else {
          this.disabled = false
        }
      } catch (error) {
        this.loadErrorCallback()
      }
    },
    goMore() {
      this.$router.push({ path: '/forgetLoginpwd' })
    },
    toRegistry() {
      // this.$emit('changeDlg', 2, '48.5vh')
      this.$emit('changeDlg', 2)
    },
    to(path) {
      this.$router.push({
        path
      })
    },
    // 校检手机号
    checkPhone(num) {
      return true
      // if (num === 123456789) return true
      // const reg = /^[1][3,4,5,7,8][0-9]{9}$/
      // if (reg.test(num)) {
      //   return true
      // }
      // return false
    },
    async onSubmit(res) {
      if (this.disabled) {
        this.$toast.fail('请勾选我是人类完成验证')
        return
      }
      this.loading = true
      // console.log(process.env.VUE_APP_BASE_PATH)
      const getUTokenRes = await getUToken()
      const logintoken = getUTokenRes.logintoken
      this.form.logintoken = logintoken
      this.$store
        .dispatch('user/login', this.form)
        .then(async(res) => {
          if (window.fbq) {
            fbq('track', 'CompleteRegistration')
          }
          if (window.ttq) {
            ttq.track('CompleteRegistration')
            ttq.track('ClickButton')
            ttq.track('Contact')
            ttq.track('AddToCart')
          }
          await this.$store.dispatch('user/getVipInfo')
          this.$toast('登录成功')
          this.$emit('closeLogin')
        })
        .catch((e) => {
          this.showCaptcha = false
          this.$nextTick(() => {
            this.disabled = true
            this.setCaptcha()
          })
          this.$toast.fail(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 定义回调函数
    callback(res) {
      // 第一个参数传入回调结果，结果如下：
      // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
      // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
      // CaptchaAppId       String    验证码应用ID。
      // bizState    Any       自定义透传参数。
      // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
      console.log('callback:', res)
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回trerror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
      if (res.ret === 0) {
        this.form.ticket = res.ticket
        this.form.randstr = res.randstr
        this.disabled = false
        // 复制结果至剪切板
        var str = '【randstr】->【' + res.randstr + '】      【ticket】->【' + res.ticket + '】'
        var ipt = document.createElement('input')
        ipt.value = str
        document.body.appendChild(ipt)
        ipt.select()
        document.execCommand('Copy')
        document.body.removeChild(ipt)
        // alert('1. 返回结果（randstr、ticket）已复制到剪切板，ctrl+v 查看。\n2. 打开浏览器控制台，查看完整返回结果。');
      }
      document.getElementsByClassName('tencent-captcha-dy__robot-checkBox-img-done')[0].src = this.checkedBox
    },

    // 定义验证码js加载错误处理函数
    loadErrorCallback() {
      var appid = 'CaptchaAppId'
      // 生成容灾票据或自行做其它处理
      var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000)
      this.callback({
        ret: 0,
        randstr: '@' + Math.random().toString(36).substr(2),
        ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error'
      })
    }

    // 定义验证码触发事件
    // window.onload = function(){

    // }
  }
}
</script>

<style lang="less">

.login-container {
  background-color: rgba(32,42,67,1);
  border-radius: 30px;
  // height: 814px;
  .close-icon{
      position: absolute;
      // top: 24px;
      // right: 24px;
      bottom: -92px;
      left: calc(50% - 26px);
      z-index: 9;
      height: 52px;
      width:52px;
      background: url(~@/assets/portal/auth/icon_close.svg);
      background-size: 100% 100%;
  }
  .checkIcon{
    height: 32px;
    width:32px;
    margin:6px 0;
  }
  .marginLeft8{
    margin-left: 16px;
  }
  .other-type{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 48px;
    .main-text{
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 600;
    }
    .line{
      width: 72px;
      height: 1px;
      background-color: rgba(255, 255, 255,0.2);
      margin: 0 6px;
    }
    .text{
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: rgba(255, 255, 255,0.65);
      font-weight: 400;
    }
    .type-item{
      height:64px;
      width:64px;
      margin: 0 24px;
      // background-size: cover;
      // background-repeat: no-repeat;
      // background-position: center;
      // cursor: pointer;
    }
  }
  .cell_icon1{
    height: 40px;
    width: 40px;
    background: url(~@/assets/portal/auth/icon_账号.svg);
    margin: 24px 0 24px 28px;
  }
  .cell_icon2{
    height: 40px;
    width: 40px;
    background: url(~@/assets/portal/auth/icon_密码.svg);
    margin: 24px 0 24px 28px;
  }
  .submit_btn{
    height: 88px;
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    color: var(--btn-text-color);
    // letter-spacing: 1px;
    text-align: center;
    font-weight: 600;
    // border: none;
    background: var(--button-home-popup-login);
    // border-radius: 12px;
    // background-color: transparent;
    // border-color:var(--btn-bg-border-color);
    // box-shadow: var(--btn-bg-box-shadow);
    // border-width: 0.5px;
    // border-style: solid;
    // border-radius: 64px;
  }
  .content{
    border-radius: 30px;
    // height: 500px;
    // background-image: linear-gradient(244deg, #001ECF 0%, #C91EFB 95%);
    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 116px 40px 48px 40px;
    .header__title {
      text-align: left;
      font-family: PingFangSC-Semibold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 48px;
      font-weight: 600;
    }
    .notice-line{
      display: flex;
      color: #fff;
      margin-top: 30px;
      // margin-bottom: 30px;
      font-size: 28px;
      font-weight: 400;
      font-family: PingFangSC-Regular;
      line-height: 44px;
      .main{
        color: var(--text-color);
        margin-left:12px;
      }
      .service_icon{
        height: 44px;
        width: 44px;
        // float: right;
      }
      .forget{
        color:  var(--text-color);
        margin-left: auto;
        line-height: 40px;
        // border-bottom: 1px solid
            // border-bottom-color: #283249;
            // border-bottom-style: solid;
            // border-bottom-width: 2px;
      }
    }
    .other{
      font-size: 3vw;
      color: #999;
      text-align: center;
      margin: 2.4vh 0 2vh 0;
    }
  }
  .form {
    // width: 70vw;
    // background: red;
    // padding: 24px;
    margin-top: 2.4vh;
  }
}
.tencent-captcha-dy__robot-box {
  width:inherit !important;
  background-color: unset !important;
  border: none !important;
  padding: 0 !important;
}
.tencent-captcha-dy__robot-left-checkBox{
  height: 32px !important;
  width: 32px !important;
  border: none !important;
  // border-radius: 50% !important;
  margin-right: 16px !important;
  background-color: transparent !important;
  background-image:url(~@/assets/portal/auth/复选框_n@2x.webp);
  background-size: 100% 100% !important;
}
.tencent-captcha-dy__robot-box-mini {
    height: 60px !important;
}
.tencent-captcha-dy__robot-left-wrapper {
  height: unset !important;
  line-height: unset !important;
}
.tencent-captcha-dy__robot-box .tencent-captcha-dy__robot-left-wrapper .tencent-captcha-dy__robot-left-div {
    font-weight: 400 !important;
    color: #fff !important;
}
.tencent-captcha-dy__robot-checkBox-img-loading {
  width: 32px !important;
  top: 0 !important;
  left: 0 !important;
}
.tencent-captcha-dy__robot-checkBox-img-done {
  width: 32px !important;
}
// #tcaptcha_transform_dy{
//   left: calc(50% - 360px) !important;
// }
.tencent-captcha-dy__robot-left-div-box{
  display: flex !important;
}
.tencent-captcha-dy__robot-left-div{
  margin-top: unset !important;
  line-height: unset !important;
  font-size: 28px !important;
  // font-family: unset !important;
}
.tencent-captcha-dy__robot-right-wrapper-privacy-box{
  line-height:32px !important;
}
</style>
